
import layerEvents from "../utils/layerEvents";
import Workmode from "../classes/Workmode";
import WorkmodeProject from "../classes/WorkmodeProject";
import { Pentagon, Info, Building, Polygon, DotsThreeVertical, Book, PencilLine, Palette, Trash, CircleNotch, Warning  } from "@phosphor-icons/react";
import {Dropdown, Button, Row, Col} from "react-bootstrap";


class WorkmodeComp extends WorkmodeProject {


	constructor() {
		super();


	}
	contextMenu(){
		return [{
			name:'',
			cell: row => {
				if(row.unknown || row.id < 0)
					return <div className="context-menu" data-tag="allowRowEvents"></div>;
				return (
					<div className="context-menu" data-tag="allowRowEvents">
						<Dropdown className="minimal">
							<Dropdown.Toggle className="p-0 px-1" variant="default">
								<DotsThreeVertical size={16} />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item href="#" onClick={(e)=>{this.handleEditOwner(row); }}><PencilLine weight="bold" size={16} /> Edit landowner</Dropdown.Item>
								<Dropdown.Item href="#" onClick={(e)=>{this.openDissasociateProperty(row); }} className="text-danger" ><Trash weight="bold" size={16} /> Detach owner</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
						<CircleNotch className="spin" size={16} />
						<Warning className="text-danger" size={16} />
					</div>
				);
			},
			width:"20px",
			style: {
				paddingRight: '.3em !important',
			}
		}];
	}
	propertyAttributes(land, landOwners){
		const {getters} = this.context;
		var stats = [0,0];
		if(landOwners.length){

			const lId = landOwners[0]

			const o = this.tc.scenario.landowners.find((ow)=>{return ow.id == lId});

			if(o){
				const prop = o.properties.find((p)=>{return p.id == land.properties.vindrid});
				if(prop && prop.area && prop.totalArea)
					stats = [prop.totalArea, prop.area];
			}
			else {
				stats = [0,0];
			}
		}
		
		return (
			<>
				{!!land.properties.vindrid &&
				<Row className="basic-info mb-2">
					<Col xs="12">
						<i className="ri-circle-fill mr-2" style={{color:land.properties.color}}></i>

						<button className="btn btn-text p-0">
							<b>ID: </b>
							{land.properties.vindrid }
						</button>
					</Col>
				</Row>
				}


				{landOwners.length>1 &&
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Info className="text-warning mr-2" size={16} />
						This property has multiple owners
					</Col>
				</Row>
				}

				{!!land.properties.name && 
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Building size={16} />
						<b>Name: </b>
						{land.properties.name}
					</Col>
				</Row>
				}
				
			</>
		);
	}
}

export default WorkmodeComp;